/**
 * @name Documents Config
 * @memberof module:common/config
 * @type {Config}
 * @return {Object} Configurations of API
 */

// #region common
import API from '../config';

const base = `${API.BASE_DEV_HOST}/api/documents`;
const longRunningServer = `${API.ECS_HOST || API.BASE_DEV_HOST}/api/documents`;

export const getPreSignedUrl = (mdId: string, fileType: string, autoClassify: boolean = false) =>
  `${base}/file-upload-request/${mdId}?file_type=${fileType}&auto_classify=${autoClassify}`;
export const getCompanyDocuments = (companyId: string) => `${base}/company/${companyId}`;
export const createFileRepresentation = (documentsId: string) => `${base}/${documentsId}/files`;
export const downloadDocument = (fileId: string, firmId: string) => `${base}/download/${fileId}?firm_id=${firmId}`;
export const downloadDocumentContent = (fileId: string, firmId: string) =>
  `${longRunningServer}/download-content/${fileId}?firm_id=${firmId}&base64=true`;
export const updateOrDeleteDocument = (documentsId: string, fileId: string) => `${base}/${documentsId}/files/${fileId}`;
export const getFeaturesObjects = (mdId: string) => `${base}/feature-objects/${mdId}`;
export const addDocumentReference = (mdId: string, fileId: string) => `${base}/reference/${mdId}/${fileId}`;
export const getReferencesByMeasurementDateId = (mdId: string) => `${base}/${mdId}/references`;
export const createSubFolder = (docsId: string) => `${base}/${docsId}/folder`;
export const updateSubFolder = (docsId: string, folderId: string) => `${base}/${docsId}/folder/${folderId}`;
export const addFilesToFolder = (docsId: string) => `${base}/${docsId}/add-to-folder`;
export const validateDocumentRequestToken = (requestId: string, token: string) =>
  `${base}/requests/validate-token/${requestId}/${token}`;
export const generatePostSignedUrlViaHMACToken = (requestId: string, token: string, mdId: string, type: string) =>
  `${base}/requests/${requestId}/${token}/signed-url/${mdId}?file_type=${type}`;
export const updateRequestedFileUploadStatus = (requestId: string, token: string) =>
  `${base}/requests/file-upload-status/${requestId}/${token}`;
export const markRequestedFileFulfillmentPortal = (
  requestId: string,
  token: string,
  requestedFileId: number | string
) => `${base}/requests/${requestId}/${token}/fulfillment/${requestedFileId}`;
export const markRequestedFileFulfillment = (requestedFileId: number | string) =>
  `${base}/requested-file/${requestedFileId}/fulfillment`;
export const sendDocumentRequest = `${base}/request`;
export const updateTaskStatusFromPortal = (requestId: string, token: string, taskId: string) =>
  `${base}/requests/${requestId}/${token}/task-status/${taskId}`;
export const hasDocuments = (companyId: string, measurementDateId: string) =>
  `${base}/has-documents/${measurementDateId}/${companyId}`;

export const getDocumentById = (documentId: string) => `${longRunningServer}/references/${documentId}`;

export const convertPdfTablesToXlsx = (fileId: string, companyId: string) =>
  `${API.BASE_DEV_HOST}/api/companies/${companyId}/documents/${fileId}/conversion`;

// Classification endpoints
export const approveClassification = (documentReferenceId: string) =>
  `${base}/classification/${documentReferenceId}/approve/`;
export const declineClassification = (documentReferenceId: string) =>
  `${base}/classification/${documentReferenceId}/decline/`;
